// extracted by mini-css-extract-plugin
export var childrenContainer = "index-module--childrenContainer--T7bEj";
export var clear = "index-module--clear--08RZY";
export var closed = "index-module--closed--ni6JO";
export var foldableSection = "index-module--foldableSection--GzXHx";
export var header = "index-module--header--VY6AG";
export var opened = "index-module--opened--Ys34w";
export var title = "index-module--title--UW6Dl";